import { useState, type FormEvent } from "react";
import { submitFormData } from "@/utils/submitForm";

const SUBSCRIBE_URL = "https://readdy.ai/api/form/dahfoqbp14a1h3mr6l2g";

export default function SubscribeForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (status === "loading") return;
    const formEl = event.currentTarget;
    setStatus("loading");
    setMessage("");

    const result = await submitFormData(
      SUBSCRIBE_URL,
      formEl,
      "订阅成功！每天的精选热点会准时送到你的邮箱。"
    );

    if (result.ok) {
      setStatus("success");
      setMessage(result.message);
      formEl.reset();
    } else {
      setStatus("error");
      setMessage(result.message);
    }
  };

  return (
    <form
      id="subscribe-hotspot-daily"
      data-readdy-form
      onSubmit={handleSubmit}
      className="w-full"
    >
      <div className="flex flex-col gap-3 sm:flex-row">
        <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-3">
          <i className="ri-mail-line text-foreground-400" aria-hidden="true"></i>
          <input
            type="email"
            name="email"
            required
            autoComplete="email"
            placeholder="输入你的邮箱地址"
            aria-label="邮箱地址"
            className="w-full bg-transparent font-label text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
          />
        </div>
        <button
          type="submit"
          disabled={status === "loading"}
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {status === "loading" ? "提交中…" : "订阅速览"}
        </button>
      </div>

      <div className="contact-alt-wrap" aria-hidden="true">
        <label htmlFor="subscribe-website-alt">请勿填写此栏</label>
        <input
          id="subscribe-website-alt"
          type="text"
          name="website_alt"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden={true}
          readOnly
        />
      </div>

      {message && (
        <p
          role="status"
          className={`mt-3 font-label text-xs ${
            status === "success" ? "text-primary-700" : "text-secondary-700"
          }`}
        >
          {status === "success" ? (
            <i className="ri-checkbox-circle-line mr-1" aria-hidden="true"></i>
          ) : (
            <i className="ri-error-warning-line mr-1" aria-hidden="true"></i>
          )}
          {message}
        </p>
      )}
    </form>
  );
}